export default {
  'workflowSettings.title': 'Approval Workflows',
  'workflowSettings.description':
    'Select a workflow for each business function. Manage workflow steps and approvers in the Approval Center.',
  'workflowSettings.scope':
    'Connected functions proceed directly without a binding and require approval when bound. Other bindings take effect when their functions are connected.',
  'workflowSettings.connection': 'Integration',
  'workflowSettings.connected': 'Connected',
  'workflowSettings.pendingConnection': 'Pending',
  'workflowSettings.openCenter': 'Open Approval Center',
  'workflowSettings.refresh': 'Refresh Workflows',
  'workflowSettings.function': 'Business Function',
  'workflowSettings.section': 'Business Section',
  'workflowSettings.domain': 'Business Area',
  'workflowSettings.investment': 'Investment Projects',
  'workflowSettings.fund': 'Funds & Fundraising',
  'workflowSettings.portfolio': 'Post-investment Management',
  'workflowSettings.exit': 'Exit Management',
  'workflowSettings.legacy': 'Legacy Functions',
  'workflowSettings.legacyHint':
    'Existing bindings for legacy functions are preserved here and can be replaced or cleared. Configure current functions in their business area.',
  'workflowSettings.workflow': 'Approval Workflow',
  'workflowSettings.selectWorkflow': 'Select a published workflow',
  'workflowSettings.status': 'Binding Status',
  'workflowSettings.bound': 'Bound',
  'workflowSettings.unbound': 'Unbound',
  'workflowSettings.unsaved': 'Unsaved',
  'workflowSettings.unavailable': 'Unavailable',
  'workflowSettings.action': 'Action',
  'workflowSettings.save': 'Save',
  'workflowSettings.binding': 'Binding',
  'workflowSettings.saved': 'Workflow binding saved',
  'workflowSettings.saveFailed': 'Could not save. Please try again.',
  'workflowSettings.search': 'Search business functions',
  'workflowSettings.filterDomain': 'Filter business area',
  'workflowSettings.allDomains': 'All Business Areas',
  'workflowSettings.noWorkflow': 'No workflows available',
  'workflowSettings.noWorkflowHint':
    'Create and publish a workflow in the Approval Center, then refresh this list.',
  'workflowSettings.templateError':
    'Could not load workflows. Refresh to retry. Existing bindings are preserved.',
  'workflowSettings.loadFailed': 'Could not load bindings. Refresh to retry.',
  'workflowSettings.noFunction': 'No matching business functions',
};
